import { render, staticRenderFns } from "./PgMeiView.vue?vue&type=template&id=630f1be0&"
import script from "./PgMeiView.vue?vue&type=script&lang=js&"
export * from "./PgMeiView.vue?vue&type=script&lang=js&"
import style0 from "./PgMeiView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports